@if (isLoggingOut()) {
  <div class="logout-overlay">
    <div class="logout-content">
      <at-spinner text="Logging out..." />
    </div>
  </div>
}

<!--
  Landmarks, in reading order. There is exactly one <main>, here, and it holds only the routed
  page: every piece of repeated chrome is a sibling before or after it, so the skip link lands past
  all of it.

  Banner rule: a route with chrome has exactly one banner, and it is whichever piece of chrome is
  drawn. Signed-out and below the XL breakpoint that is the design system's header (<at-header>
  renders a <header>); on a desktop dashboard it is the sidebar, which is a <header> for the same
  reason (brand, nav, account). The full-screen routes (the maps, the subscription spinners) draw
  no chrome, so they have no banner and no nav either.

  No other <header> may be a banner. A page's own <header> renders inside <main>, where it is
  scoped away; a dialog renders in the CDK overlay, OUTSIDE <main>, so a dialog's head is a <div>
  (as `app-modal-wrapper`'s is) or sits inside a <section>, never a bare <header>.
-->
<div class="wrapper">
  <app-skip-link />

  @if (isHeaderVisible()) {
    <app-header-wrapper />
  }

  @if (isSidebarVisible()) {
    <app-dashboard-sidebar />
  }

  <main class="main" id="main-content" tabindex="-1">
    <router-outlet />
  </main>

  @if (isUIVisible()) {
    <at-footer appCookieSettingsLinks [class.has-sidebar]="isSidebarVisible()" [links]="footerLinks">
      <p class="footer-text">© 2026 AnotherTrip. All rights reserved.</p>
    </at-footer>
  }
</div>

@if (!isLoggingOut()) {
  <app-map-job-notices />
}
